var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"icons-page",attrs:{"fluid":""}},[_c('v-row',{staticClass:"d-flex justify-space-between mt-2 mb-2",attrs:{"no-gutters":""}},[_c('v-col',[_c('Table',{attrs:{"newItemLabel":"All Orders","title":_vm.title,"api":_vm.api,"filter":_vm.filter,"create":_vm.create,"del":_vm.del,"edit":_vm.edit,"headers":_vm.headers},on:{"openForm":_vm.setForm,"update_page":(val) => {
            _vm.page = val;
          }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }